<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="mb-5 background_color">
  <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" to="/issuetracking/index"> {{language[1]['Home']}} </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/contractors/index"> {{language[5]['Manage Contractor']}}</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> {{contractor.name1}}  </h6>


  <b-modal :id="infoModal1.id" 
  
  size="sm" hide-footer
  > 
  <div>
   <img :src="uploadedFile" alt="Profile picture" width="100%"/>
  </div>
 </b-modal>


  <div class="container-fluid">
 
    <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                <div >




                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">


    <table style="font-size: small; " class="table table-hover  table-sm table-borderless   ">
       
          <tbody>

            <tr>
              <td class="width-custom2"><b>Id </b></td>
             <td>{{ contractor.id}}</td> 
               <td style="text-align: right;">   <button type="button" @click="Update(contractor.id)" class="btn font-size_def btn-sm btn-outline-primary bdr-rad me-1">{{language[78]['Update']}}</button>
                <button type="button" @click="inactive(contractor.id)" v-show="contractor.status==1" class="btn font-size_def btn-sm btn-outline-primary bdr-rad">{{language[56]['Inactive']}}</button>
                <button type="button" @click="active(contractor.id)" v-show="contractor.status==2"   class="btn font-size_def btn-sm btn-outline-primary bdr-rad">{{language[55]['Active']}}</button>
            </td> 
            </tr>
            <tr>
              <td><b> {{language[57]['Contractor Name']}}</b></td>
             <td>{{contractor.name1}}</td> 
             <td></td>
            </tr>

            <tr v-if="uploadedFile">
  <td><b>{{language[58]['Profile picture']}}</b></td>
  <td>
    <a style="cursor:pointer"  @click="imageLoad(uploadedFile)" >
      <img :src="uploadedFile" alt="Profile picture" style="max-width: 100px;" />
    </a>
  </td> 
  <td></td> 
</tr>



            <tr>
              <td><b>{{language[75]['Mobile']}}</b></td>
             <td>{{ contractor.mobile}} </td> 
             <td></td>
            </tr>
           
            <tr>
              <td><b>{{language[76]['Email']}}</b></td>
             <td>{{contractor.email}}</td> 
             <td></td>
            </tr>
            
          
            <tr>
              <td><b>{{ language[16]['Main Category'] }}</b></td>
             <td>{{contractor.work_typ1 }}</td> 
             <td></td>
            </tr>
            <tr>
              <td><b>{{ language[17]['Sub Category'] }}</b></td>
             <td>{{contractor.work_typ2 }}</td> 
             <td></td>
            </tr>
    



            <tr>
              <td><b>{{language[22]['Status']}}</b></td>
             <td>{{contractor.status1 }}</td> 
             <td></td>
            </tr>
           
            <tr>
              <td><b>{{language[23]['Created Date']}}</b></td>
             <td>{{contractor.created_date }}</td> 
             <td></td>
            </tr>
           
           
             
          </tbody>


        </table>
       


        </div>
        </div>


        <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>{{language[59]['Allocate Issues']}}</b></h6>

                        <div class="table-responsive">
                      
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>{{language[14]['Ticket Number']}}</th>
                              <th>{{language[15]['Citizen Name']}}</th>
                              <th>{{language[16]['Main Category']}}</th>
                              <th>{{language[18]['Sub Category']}}</th>
                              <th>{{language[55]['Citizen Mobile']}}</th>
                              <th>{{language[19]['Citizen Email']}}</th>
                              <th>{{language[22]['Status']}}</th>
                              <th>{{language[23]['Created Date']}}</th>
                            
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(detail, index) in details" :key="detail.id">
                              <td>{{index+1}}</td>
                              <td>{{detail.issue_no}}</td>
                              <td>{{detail.name1}}</td>
                              <td>{{detail.main_category}}</td>
                              <td>{{detail.sub_category}}</td>
                              <td>{{detail.mobile}}</td>
                              <td>{{detail.email}}</td>
                              <td>
                                <span v-show="detail.status==1" class="badge bg-danger">
                                    {{ detail.status1 }} 
                                </span>
                                <span style="background-color: #ee68f9;" v-show="detail.status==42" class="badge">
                                    {{ detail.status1 }} 
                                </span>
                                <span  v-show="detail.status==49" class="badge bg-success">
                                    {{ detail.status1 }} 
                                </span>
                              </td>
                              <td>{{detail.created_date}}</td>
                              <td></td>
                            
                              </tr>
                            </tbody>

                          </table>
    
                        </div>

                        </div>
                    </div>


   
    

    




</div>
</div>
</div>
<br><br><br>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import httpClient from '@/axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        language:JSON.parse(authService.isLanguage()),
        'id':this.$route.query.id,
        uploadedFile:'',
        contractor:{},
        details:[],
        isLoading:true,
       
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },


        
      }

    },
    mounted(){
 
  this.loadCrm();
    },

    computed: {
    roundToTwoDecimal() {
      return detail => parseFloat(detail).toFixed(2);
    }
  },
methods : {

  async imageLoad(id){

this.infoModal1.content = id;
this.$root.$emit('bv::show::modal', this.infoModal1.id);

},

    Update(id){
    this.$router.push('/contractors/update?id='+id);
  },

  
    async inactive(id) {
  
  try {
    const { data} = await  httpClient.get('/web/api/contractors/inactive?id='+id,{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
     if(data.status==200){
      this.loadCrm();
     }
    
  } catch (error) {
    console.log(error.response);
  }
},
async active(id) {

  try {
    const { data} = await  httpClient.get('/web/api/contractors/active?id='+id,{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
     if(data.status==200){
      this.loadCrm();
     }
    
  } catch (error) {
    console.log(error.response);
  }
},


      


  
  
  async loadCrm() {
   
    try {
      const { data} = await  httpClient.get('/web/api/contractors/view?id='+this.id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.contractor = data.contractor;
        this.details = data.details;
        this.uploadedFile = data.uploadedFile;
       this.isLoading= false;
      
    } catch (error) {
      console.log(error.response);
    }
  },




},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style >

</style>